import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative w-full bg-[#FAF7F2] overflow-hidden pt-12 pb-16 lg:pt-24 lg:pb-24" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-148">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="z-10" data-id="element-149">
            <span className="inline-block px-4 py-2 rounded-full bg-[#E07856]/10 text-[#E07856] font-semibold text-lg mb-6" data-id="element-150">
              Para mujeres de 65+
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2D3748] leading-tight mb-6" data-id="element-151">
              No es gordura: <br data-id="element-152" />
              <span className="text-[#E07856]" data-id="element-153">es hinchazón.</span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-700 mb-8 leading-relaxed max-w-lg" data-id="element-154">
              14 días para sentir tu cintura otra vez. Sin dietas extremas, sin
              ejercicios dolorosos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-155">
              <motion.button onClick={scrollToCTA} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center justify-center px-8 py-4 text-xl font-bold text-white bg-[#E07856] rounded-lg shadow-lg hover:bg-[#c96242] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E07856]" data-id="element-156">
                Empezar mi plan
                <ArrowRight className="ml-2 h-6 w-6" data-id="element-157" />
              </motion.button>
            </div>
            <p className="mt-4 text-gray-600 text-lg" data-id="element-158">
              * Diseñado específicamente para tu metabolismo actual
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-159">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-160">
              <img src="https://cdn.magicpatterns.com/uploads/eZDyRrCt8wNLQ5U3ozSEzW/gemini-generated-image-1769032605225.png" alt="Guía del programa 14 Días Desinflámate en una tablet" className="w-full h-auto object-cover" data-id="element-161" />
            </div>
            {/* Decorative element */}
            <div className="absolute -z-10 top-10 -right-10 w-full h-full bg-[#8BA888]/20 rounded-full blur-3xl" data-id="element-162" />
          </motion.div>
        </div>
      </div>
    </section>;
}